import { Create, Edit } from 'react-admin';
import { TagForm, TagList } from '../tag';
import { EditToolbar } from '@components/EditToolbar';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

export const ConversationTagList = TagList;

export const ConversationTagCreate = () => (
  <Create>
    <TagForm domain="conversation" />
  </Create>
);

export const ConversationTagEdit = () => (
  <Edit mutationMode="pessimistic">
    <TagForm domain="conversation" toolbar={<EditToolbar />} />
  </Edit>
);

export const ConversationTagIcon = LocalOfferIcon;
